export const required = value => (value ? undefined : 'Campo requerido.');
export const cpf = value => (value && validaCpf(value) ? undefined : 'CPF Inválido.');
export const cnpj = value => (value && validaCnpj(value) ? undefined : 'CNPJ Inválido.');
export const number = value =>
  value && isNaN(Number(value)) ? 'O campo aceita somente números.' : undefined;
export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Email inválido' : undefined;

export const cpfCnpj = value => {
  if (value) {
    // Remove apenas caracteres não alfanuméricos (preserva letras do CNPJ alfanumérico)
    const limpo = value.toString().toUpperCase().replace(/[^A-Z0-9]/g, '');

    if (limpo.length == 14) {
      if (validaCnpj(value)) {
        return undefined;
      } else {
        return 'Inscrição inválida.';
      }
    } else if (limpo.length == 11) {
      if (validaCpf(value)) {
        return undefined;
      } else {
        return 'Inscrição inválida.';
      }
    } else {
      return undefined;
    }
  } else {
    return undefined;
  }
};

export const validaEmail = email => {
  if (!email) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

/**
 * Valida CNPJ numérico e alfanumérico (novo formato Receita Federal).
 * Aceita entrada com ou sem máscara (XX.XXX.XXX/XXXX-DD).
 * Conversão via código ASCII - 48: dígitos 0-9, letras A=17, ..., Z=42.
 */
export function validaCnpj(values) {
  const cnpj = values.toString().toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (cnpj.length !== 14) return false;

  // Rejeita CNPJs com todos os caracteres iguais
  if (/^(.)\1+$/.test(cnpj)) return false;

  // Converte caractere para valor numérico: código ASCII - 48 (dígitos 0-9, letras A=17..Z=42)
  const charParaNumero = c => c.charCodeAt(0) - 48;

  const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const calcDigito = pesos => {
    const soma = pesos.reduce((acc, p, i) => acc + charParaNumero(cnpj[i]) * p, 0);
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  const d1 = calcDigito(pesos1);
  const d2 = calcDigito(pesos2);

  return parseInt(cnpj[12]) === d1 && parseInt(cnpj[13]) === d2;
}

export function validaCpf(cpf) {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf == '') return false;
  // Elimina CPFs invalidos conhecidos
  if (
    cpf.length != 11 ||
    cpf == '00000000000' ||
    cpf == '11111111111' ||
    cpf == '22222222222' ||
    cpf == '33333333333' ||
    cpf == '44444444444' ||
    cpf == '55555555555' ||
    cpf == '66666666666' ||
    cpf == '77777777777' ||
    cpf == '88888888888' ||
    cpf == '99999999999'
  )
    return false;
  // Valida 1o digito
  let add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev == 10 || rev == 11) rev = 0;
  if (rev != parseInt(cpf.charAt(9))) return false;
  // Valida 2o digito
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev == 10 || rev == 11) rev = 0;
  if (rev != parseInt(cpf.charAt(10))) return false;
  return true;
}
export function RemoveCaracteres(values) {
  if (values) {
    const texto = values.replace(/[^\d]+/g, '');
    return texto;
  }
}
